// ═══════════════════════════════════════════════
//   DAILY REWARDS — 11-day Dokomi campaign
// ═══════════════════════════════════════════════

const {S, DAILY_CAMPAIGN, addPts, toast, todayStr, scheduleSave} = window;

function dayDiff(a, b) {
    const da = new Date(a + 'T00:00:00');
    const db = new Date(b + 'T00:00:00');
    return Math.round((db - da) / 86400000);
}

function currentDayIdx() {
    return dayDiff(DAILY_CAMPAIGN.startDate, todayStr());
}

function buildDailyStars() {
    const today = todayStr();
    const N = DAILY_CAMPAIGN.durationDays;
    const idx = currentDayIdx();
    const claimedSet = new Set(S.dailyState.claimed);
    const claimedToday = S.dailyState.lastDate === today;
    const inWindow = idx >= 0 && idx < N;
    const beforeStart = idx < 0;
    const afterEnd = idx >= N;

    let subText;
    if (beforeStart) {
        const d = -idx;
        subText = `Starts in ${d} day${d === 1 ? '' : 's'} · 18 May.`;
    } else if (afterEnd) {
        subText = 'Campaign over · thanks for stopping by!';
    } else if (claimedToday) {
        subText = `Come back tomorrow · ${claimedSet.size}/${N} claimed.`;
    } else {
        subText = `Stamp once per day · today is +${DAILY_CAMPAIGN.dayPts[idx]} pts.`;
    }
    document.getElementById('daily-sub').textContent = subText;

    const endLbl = document.getElementById('daily-end-lbl');
    const endVal = document.getElementById('daily-end-val');
    const startMs = new Date(DAILY_CAMPAIGN.startDate + 'T00:00:00').getTime();
    const endMs = startMs + N * 86400000;
    const now = Date.now();
    if (now < startMs) {
        endLbl.textContent = 'Starts in';
        endVal.textContent = formatDuration(startMs - now);
    } else if (now < endMs) {
        endLbl.textContent = 'Ends in';
        endVal.textContent = formatDuration(endMs - now);
    } else {
        endLbl.textContent = 'Status';
        endVal.textContent = 'Ended';
    }

    const earnedPts = [...claimedSet].reduce((a, i) => a + DAILY_CAMPAIGN.dayPts[i], 0);
    document.getElementById('daily-bar-fill').style.width = (claimedSet.size / N * 100) + '%';
    document.getElementById('daily-bar-meta').textContent = `${claimedSet.size} / ${N} · ${earnedPts} pts`;

    const cont = document.getElementById('dstars');
    cont.innerHTML = '';
    for (let i = 0; i < N; i++) {
        const isClaimed = claimedSet.has(i);
        const isToday = i === idx && !claimedToday && inWindow;
        const isFinale = i === N - 1;

        const card = document.createElement('div');
        card.className = 'day-card '
            + (isClaimed ? 'day-claimed' : isToday ? 'day-today' : 'day-locked')
            + (isFinale ? ' day-finale' : '');

        const icon = isClaimed ? '✓' : isToday ? '🎁' : isFinale ? '⭐' : '🔒';
        const label = `Day ${i + 1}` + (isFinale ? ' · finale' : '');

        if (isToday) {
            const badge = document.createElement('div');
            badge.className = 'day-today-badge';
            badge.textContent = 'Today';
            card.appendChild(badge);
        }

        if (isFinale) {
            card.innerHTML += `
                <div class="day-icon">${icon}</div>
                <div class="day-finale-text">
                    <div class="day-label">${label}</div>
                    <div class="day-pts">+${DAILY_CAMPAIGN.dayPts[i]} pts</div>
                </div>`;
        } else {
            card.innerHTML += `
                <div class="day-label">${label}</div>
                <div class="day-icon">${icon}</div>
                <div class="day-pts">+${DAILY_CAMPAIGN.dayPts[i]}</div>`;
        }

        if (isToday) card.addEventListener('click', () => claimDaily(i));
        cont.appendChild(card);
    }

    const allClaimed = claimedSet.size >= N;
    const prizeEl = document.getElementById('week-prize');
    const prizeDesc = document.getElementById('week-prize-desc');
    const prizeBtn = document.getElementById('week-prize-btn');
    const prizeBtnIcon = prizeBtn.querySelector('.week-prize-btn-icon');
    const prizeBtnLbl = document.getElementById('week-prize-btn-label');

    prizeDesc.textContent = DAILY_CAMPAIGN.finale.desc;

    if (S.dailyState.finaleClaimed) {
        prizeEl.classList.add('claimed');
        prizeBtn.disabled = true;
        prizeBtnIcon.textContent = '✓';
        prizeBtnLbl.textContent = 'claimed';
    } else if (allClaimed) {
        prizeEl.classList.remove('claimed');
        prizeBtn.disabled = false;
        prizeBtnIcon.textContent = '🎁';
        prizeBtnLbl.textContent = 'claim';
    } else {
        prizeEl.classList.remove('claimed');
        prizeBtn.disabled = true;
        prizeBtnIcon.textContent = '🔒';
        const left = N - claimedSet.size;
        prizeBtnLbl.textContent = `${left}d left`;
    }
}

function formatDuration(ms) {
    if (ms <= 0) return '—';
    const h = Math.floor(ms / 3600000);
    const d = Math.floor(h / 24);
    return `${d}d ${h % 24}h`;
}

function claimDaily(idx) {
    const today = todayStr();
    const cur = currentDayIdx();
    if (idx !== cur) { toast('Not today!'); return; }
    if (S.dailyState.lastDate === today) {
        toast('Already claimed today! Come back tomorrow 📅');
        return;
    }
    if (S.dailyState.claimed.includes(idx)) return;

    S.dailyState.claimed.push(idx);
    S.dailyState.claimed.sort((a, b) => a - b);
    S.dailyState.lastDate = today;
    addPts(DAILY_CAMPAIGN.dayPts[idx], `daily:day${idx + 1}`);

    if (idx === DAILY_CAMPAIGN.midMilestone.dayIdx) {
        window.unlockNick(DAILY_CAMPAIGN.midMilestone.nick);
    }

    buildDailyStars();
    toast(`+${DAILY_CAMPAIGN.dayPts[idx]} pts! Day ${idx + 1} claimed ⭐`);
    scheduleSave();
}

function claimWeekPrize() {
    if (S.dailyState.finaleClaimed) return;
    if (S.dailyState.claimed.length < DAILY_CAMPAIGN.durationDays) return;
    S.dailyState.finaleClaimed = true;
    addPts(DAILY_CAMPAIGN.finale.pts, 'daily:finale');
    if (DAILY_CAMPAIGN.finale.nick) window.unlockNick(DAILY_CAMPAIGN.finale.nick);
    buildDailyStars();
    toast(`Finale prize claimed! +${DAILY_CAMPAIGN.finale.pts} pts 🎁`);
    scheduleSave();
}

window.buildDailyStars = buildDailyStars;
window.claimDaily = claimDaily;
window.claimWeekPrize = claimWeekPrize;
